import React from "react";
// import { Link } from "react-router-dom";




export default class News extends React.Component {

    render(){
        return(
            <div>
                <div class="wrapper">
                    <section class="bread-crumb-container">
                        <div class="bread-crumb-img">
                            <img src="/assets/images/bread-crumb5.png" alt=""/>
                        </div>
                        <div class="bread-crumb-content">
                            <div class="bread-crumb-inner">
                            <h2>news</h2>
                            <a href="index.html">Home</a> - <a href="news.html">News</a>
                            </div>
                        </div> {/* <!-- bread-crumb-content --> */}
                    </section> {/* <!-- bread-crumb-container --> */}
                    <div class="main-part">
                    <section class="event-container">
                        <div class="container">
                        <div class="news-detail">
                            <div class="row">
                            <div class="col-md-9 col-sm-9 col-xs-12">
                                <div class="event-detail-wrap">
                                <div class="event-list wow fadeInDown text-left" data-wow-duration="1000ms" data-wow-delay="300ms">
                                    <div class="event-pic">
                                    <img src="/assets/images/news1.jpg" alt=""/>
                                    </div>
                                    <h3>Wedding with our food truck</h3>
                                    <span>17 august 2016 - </span><a href="#/">Weddings</a>
                                    <p> Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>
                                    <a href="#/" class="btn-black">Read more</a>
                                </div> {/* <!-- event-list --> */}
                                </div> {/* <!-- event-wrap --> */}
                                <div class="event-detail-wrap">
                                <div class="event-list wow fadeInDown text-left" data-wow-duration="1000ms" data-wow-delay="300ms">
                                    <div class="event-pic">
                                    <div class="swiper-container">
                                        <div class="swiper-wrapper">
                                            <div class="swiper-slide"><img src="/assets/images/news2.jpg" alt=""/></div>
                                            <div class="swiper-slide"><img src="/assets/images/news1.jpg" alt=""/></div>
                                            <div class="swiper-slide"><img src="/assets/images/news2.jpg" alt=""/></div>
                                        </div>
                                        <div class="swiper-pagination"></div>
                                    </div>
                                    </div>
                                    <h3>We make people laugh</h3>
                                    <span>17 august 2016 - Food</span>
                                    <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>
                                    <a href="#/" class="btn-black">Read more</a>
                                </div> {/* <!-- event-list --> */}
                                </div> {/* <!-- event-wrap --> */}
                                <div class="event-detail-wrap">
                                <div class="event-list wow fadeInDown text-left" data-wow-duration="1000ms" data-wow-delay="300ms">
                                    <div class="event-pic">
                                    <div class="overlay-video">
                                        <a href="#/">
                                        <img src="/assets/images/news3.jpg" alt=""/>
                                        <div class="overlay-news-video">
                                            <i class="fa fa-play-circle" aria-hidden="true"></i>
                                        </div> {/* <!-- overlay-news-video --> */}
                                        </a>
                                    </div>
                                    </div>
                                    <h3>Happy moments</h3>
                                    <span>17 august 2016 - Weddings</span>
                                    <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>
                                    <a href="#/" class="btn-black">Read more</a>
                                </div> {/* <!-- event-list --> */}
                                </div> {/* <!-- event-wrap --> */}
                                <div class="event-detail-wrap event-detail-noimg">
                                <div class="event-list wow fadeInDown text-left" data-wow-duration="1000ms" data-wow-delay="300ms">
                                    <h3>Because is delicious...</h3>
                                    <span>17 august 2016 - On road</span>
                                    <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>
                                    <a href="#/" class="btn-black">Read more</a>
                                </div> {/* <!-- event-list --> */}
                                </div> {/* <!-- event-wrap --> */}
                                <div class="news-pagination">
                                <ul>
                                    <li class="active"><a href="#/">1</a></li>
                                    <li><a href="#/">2</a></li>
                                    <li><a href="#/">3</a></li>
                                    <li><a href="#/"><i class="fa fa-chevron-right" aria-hidden="true"></i></a></li>
                                </ul>
                                </div> {/* <!-- news-pagination --> */}
                            </div>
                            <div class="col-md-3 col-sm-3 col-xs-12">
                                <div class="post-detail-right">
                                <div class="post-right-search">
                                    <form method="post" name="form">
                                    <div class="form-field">
                                        <input name="txt" placeholder="Type here..." type="text"/>
                                    </div>
                                    <div class="form-field text-left">
                                        <button class="btn-black">Search</button>
                                    </div> {/* <!-- form-field --> */}
                                    </form>
                                </div> {/* <!-- post-right-search --> */}
                                <div class="post-categories text-left">
                                    <h3>Categories</h3>
                                    <ul>
                                    <li><a href="#/">Weddings</a></li>
                                    <li class="active"><a href="#/">Food</a></li>
                                    <li><a href="#/">Our truck</a></li>
                                    <li><a href="#/">Recent events</a></li>
                                    <li><a href="#/">On road</a></li>
                                    </ul>
                                </div> {/* <!-- post-categories --> */}
                                <div class="post-categories text-left">
                                    <h3>Recent posts</h3>
                                    <ul>
                                    <li><a href="#/">What to do on wedding</a></li>
                                    <li class="active"><a href="#/">Food tips</a></li>
                                    <li><a href="#/">Our truck events</a></li>
                                    <li><a href="#/">A new adventure</a></li>
                                    <li><a href="#/">People meet on road</a></li>
                                    </ul>
                                </div> {/* <!-- post-categories --> */}
                                <div class="post-gallery gallery clearfix">
                                    <h3>Gallery</h3>
                                    <div class="post-gallery-item">
                                    <a href="images/post-gallery-big1.jpg" rel="prettyPhoto[gallery1]"><img src="/assets/images/post-gallery1.jpg" alt=""/></a>
                                    </div>
                                    <div class="post-gallery-item">
                                    <a href="images/post-gallery-big2.jpg" rel="prettyPhoto[gallery1]"><img src="/assets/images/post-gallery2.jpg" alt=""/></a>
                                    </div>
                                    <div class="post-gallery-item">
                                    <a href="images/post-gallery-big3.jpg" rel="prettyPhoto[gallery1]"><img src="/assets/images/post-gallery3.jpg" alt=""/></a>
                                    </div>
                                </div> {/* <!-- post-gallery --> */}
                                </div> {/* <!-- post-detail-right --> */}
                            </div>
                            </div>
                            </div> {/* <!-- post-detail --> */}
                        </div>
                    </section> {/* <!-- event-container --> */}
                    <div class="map-outer">
                        <div id="truck-locator"></div>
                    </div>
                    </div> {/* <!-- main-part --> */}
                   
                </div>
            </div>
        )
    }
}